import { z } from "zod";

export const CreateFolderSchema = z.object({
  file_name: z.string().min(1, "Folder name is required"),
  parent: z.string().optional(),
});

export type CreateFolderFormValues = z.infer<typeof CreateFolderSchema>;
